var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"pointer",staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/dashboard/banner.png")},on:{"click":_vm.$login}}),_c('text-left',{attrs:{"text-left":{
      height: 380,
      title: '银行账户信息集中显示',
      desc: '集中列示所有银行账户信息，帮助您更好的了解企业的资金状况。',
      textWidth: 510,
      imgWidth: 500,
      left: true,
      img: require('@/assets/dashboard/img1.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 360,
      title: '逾期账单一览无余，轻松实现快捷收付',
      desc: '集中显示销售及采购账单的收付状态，更好地管理逾期账款。点击仪表盘，可直接链接到与客户供应商的交易数据明细，由此及彼，了然于心。',
      textWidth: 540,
      left: false,
      imgWidth: 500,
      img: require('@/assets/dashboard/img2.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 430,
      title: '深层次了解内部成本支出，帮助您的企业开源节流',
      desc: '集中显示所有费用报销单数据，点击仪表盘，可直接链接到员工的费用报销明细。同时，费用还可按照员工、金额、报销状态以及其他核算条件等进行筛选分析。',
      textWidth: 500,
      left: true,
      imgWidth: 500,
      img: require('@/assets/dashboard/img3.png')
    }}}),_c('part-list',{attrs:{"part-list":_vm.list}}),_c('Ready')],1)}
var staticRenderFns = []

export { render, staticRenderFns }